module.exports = __webpack_public_path__ + "assets/img/ithrive-games-light.e20cf177.png";